import { formatDate } from "./versions";

// Footer of every PDF page (spec §6 E7, ADR-0007). One constant; E4 and E7 share it.
export const REPORT_FOOTER = "Bu rapor firmanın iç kontrol çıktısıdır, resmî beyan ya da Bakanlık formu değildir.";

/**
 * Spec §6 E7 section 1 (decision #70): the event date field of each source type that bounds the report period.
 * DIIB (start / end: document term, may lie in the future), RECETE and GTIP_MALZEME have no event date and are left out.
 */
export const PERIOD_DATE_FIELD = {
  GUMRUK_ITH: "registrationDate", GUMRUK_IHR: "registrationDate", ERP_STOK: "date", MUHASEBE: "date", GUVENLIK: "date", KAMERA: "date",
} as const;

/** "01.01.2026 – 30.09.2026"; "—" when no record carries an event date. Arguments are ISO dates. */
export const formatPeriod = (min: string | null, max: string | null) => (min && max ? `${formatDate(min)} – ${formatDate(max)}` : "—");
